import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import "./RegisterForm.css";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import axios from "axios";
import RefreshIcon from "@material-ui/icons/Refresh";

const initialState = {
  Fullname: "",
  Age: "",
  Occupation: "",
  Address: "",
  PhoneNO: "",
  Email: "",
  Course: "",
  Time: "",
  Expectation: "",
};
function RegisterForm() {
  const [registerData, setRegisterData] = useState(initialState);
  // const [fullname, setFullname] = useState("");
  // const [age, setAge] = useState("");
  // const [occupation, setOccupation] = useState("");
  // const [address, setAddress] = useState("");
  // const [phoneNO, setPhoneNO] = useState("");
  // const [email, setEmail] = useState("");
  // const [course, setCourse] = useState("");
  // const [time, setTime] = useState("");
  // const [expectation, setExpectation] = useState("");

  const submitRegistration = () => {
    // var data = {
    //   Fullname: fullname,
    //   Age: age,
    //   Occupation: occupation,
    //   Address: address,
    //   PhoneNO: phoneNO,
    //   Email: email,
    //   Course: course,
    //   Time: time,
    //   Expectation: expectation,
    // };
    var config = {
      method: "post",
      url: "https://localhost:44300/api/Registration/PostRegistration",
      headers: {
        "Content-Type": "application/json",
      },
      data: registerData,
    };

    axios(config)
      .then(function (response) {
        alert(response.data);
      })
      .catch(function (error) {
        alert(error);
      });
    setRegisterData(initialState);
  };

  return (
    <div className="regist">
      <Typography className="topic">Welcome to Register form</Typography>
      <div className="register">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={6} xl={6}>
            <div className="register-image">
              <img src="/image/programming2.jpg" alt="programming" />
              {/* <img src="/image/programming2.jpg" alt="programming" /> */}
            </div>
          </Grid>
          <Grid item xs={12} md={6} lg={6} xl={6}>
            <div className="register_form">
              <Typography
                style={{
                  textAlign: "center",
                  fontSize: "22px",
                  fontWeight: "700",
                }}
              >
                Register Form
              </Typography>
              <Typography style={{ textAlign: "left", fontWeight: "700" }}>
                General Information
              </Typography>
              <br />
              <div>
                <Grid className="Register_input" container spacing={2}>
                  <Grid item>
                    <Grid container>
                      <Grid item xs={8}>
                        <TextField
                          variant="outlined"
                          label="Full-name"
                          size="small"
                          type="text"
                          fullWidth
                          value={registerData.Fullname}
                          onChange={(e) =>
                            setRegisterData({
                              ...registerData,
                              Fullname: e.target.value,
                            })
                          }
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <TextField
                          variant="outlined"
                          label="Age"
                          size="small"
                          type="Number"
                          fullWidth
                          value={registerData.Age}
                          onChange={(e) =>
                            setRegisterData({
                              ...registerData,
                              Age: e.target.value,
                            })
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      label="Occupation"
                      size="small"
                      type="text"
                      fullWidth
                      value={registerData.Occupation}
                      onChange={(e) =>
                        setRegisterData({
                          ...registerData,
                          Occupation: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      label="Address"
                      size="small"
                      type="text"
                      fullWidth
                      value={registerData.Address}
                      onChange={(e) =>
                        setRegisterData({
                          ...registerData,
                          Address: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item>
                    <Grid container>
                      <Grid item xs={6}>
                        <TextField
                          variant="outlined"
                          label="Phone Number"
                          size="small"
                          type="number"
                          fullWidth
                          value={registerData.PhoneNO}
                          onChange={(e) =>
                            setRegisterData({
                              ...registerData,
                              PhoneNO: e.target.value,
                            })
                          }
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          variant="outlined"
                          label="E-mail Address"
                          size="small"
                          type="email"
                          fullWidth
                          value={registerData.Email}
                          onChange={(e) =>
                            setRegisterData({
                              ...registerData,
                              Email: e.target.value,
                            })
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
              <br />
              <Typography style={{ textAlign: "left", fontWeight: "700" }}>
                Course selection
              </Typography>
              <Grid item>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel htmlFor="age-native-simple">
                        Select Course
                      </InputLabel>
                      <Select
                        native
                        value={registerData.Course}
                        onChange={(e) =>
                          setRegisterData({
                            ...registerData,
                            Course: e.target.value,
                          })
                        }
                      >
                        <option aria-label="None" value="" />
                        <option value="Beginner course">Beginner Course</option>
                        <option value="Advanced course">Advanced Course</option>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel htmlFor="age-native-simple">
                        Select Time
                      </InputLabel>
                      <Select
                        native
                        value={registerData.Time}
                        onChange={(e) =>
                          setRegisterData({
                            ...registerData,
                            Time: e.target.value,
                          })
                        }
                      >
                        <option aria-label="None" value="" />
                        <option value="Morning">Sat-Sun (8:00 - 12:00)</option>
                        <option value="Afternoon">
                          Sat-Sun (13:00 - 17:00)
                        </option>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item>
                <TextField
                  variant="outlined"
                  label="Expectation"
                  size="small"
                  type="text"
                  multiline
                  rows={4}
                  fullWidth
                  value={registerData.Expectation}
                  onChange={(e) =>
                    setRegisterData({
                      ...registerData,
                      Expectation: e.target.value,
                    })
                  }
                />
              </Grid>
              <br />
              <Button
                variant="contained"
                color="secondary"
                style={{ width: "150px" }}
                startIcon={<KeyboardArrowUpIcon />}
                onClick={submitRegistration}
                disabled={
                  (!registerData.Fullname,
                  !registerData.Age,
                  !registerData.Occupation,
                  !registerData.Address,
                  !registerData.PhoneNO,
                  !registerData.Email,
                  !registerData.Course,
                  !registerData.Time,
                  !registerData.Expectation)
                }
              >
                Submit
              </Button>
              &nbsp; &nbsp;
              <Button
                variant="contained"
                color="primary"
                style={{ width: "150px" }}
                startIcon={<RefreshIcon />}
                onClick={() => setRegisterData(initialState)}
                disabled={
                  (!registerData.Fullname,
                  !registerData.Age,
                  !registerData.Occupation,
                  !registerData.Address,
                  !registerData.PhoneNO,
                  !registerData.Email,
                  !registerData.Course,
                  !registerData.Time,
                  !registerData.Expectation)
                }
              >
                Refresh
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default RegisterForm;
